import React from 'react';
import { CustomMaterialTable } from '../../../common/CustomMaterialTable';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import {DialogBoxMedium} from '../../../common/dialog.medium';
import Typography from '@mui/material/Typography';
import FormHelperText from '@mui/material/FormHelperText';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import TextareaAutosize from '@mui/material/TextareaAutosize';
import InputAdornment from '@mui/material/InputAdornment';
const DialogAdjustments = (p) => {
    const getYear = () => {
        return new Date().getFullYear();
    }
    const currentYear = getYear();
    const years = [];
    for(var i = currentYear; i >= currentYear-5; i--){
        years.push(i);
    }
    const {FormProps:props} = p;
        return (
            <form className="form-fullwidth">
                <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                        <FormControl variant="standard">
                            <InputLabel htmlFor="years" required error={props.Errors.year && true}>Year</InputLabel>
                            <Select
                                value = { props.FormFields.year }
                                onChange = { props.HandleOnChange }
                                inputProps = {{
                                    name: 'year',
                                    id: 'year',
                                }}>
                                { years.map((c) =>
                                    <MenuItem value={c} >{c}</MenuItem>
                                )}
                            </Select>
                            { props.Errors.year && <FormHelperText className = 'error' > {props.Errors.year}</FormHelperText> }
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <FormControl variant="standard">
                            <InputLabel htmlFor="component_id" required error={props.Errors.component_id && true}>Component</InputLabel>
                            <Select
                                value = { props.FormFields.component_id }
                                onChange = { props.HandleOnChange }
                                inputProps = {{
                                    name: 'component_id',
                                    id: 'component_id',
                                }}>
                                {typeof(props.ConfigComponents) !== 'undefined' && props.ConfigComponents.map((c, i) =>
                                    <MenuItem value={c.id} key={'c-'+i} data-component={c.title}>{c.title}</MenuItem>
                                )}
                            </Select>
                            {props.Errors.component_id && <FormHelperText className = 'error'> {props.Errors.component_id} </FormHelperText>}
                        </ FormControl>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <FormControl>
                           <TextField variant="standard"
                                id = "adjusted_amount"
                                name = "adjusted_amount"
                                label = "Amount"
                                type = "number"
                                required
                                value = { props.FormFields.adjusted_amount ?? "" }
                                onChange = { props.HandleOnChange }
                                error = { props.Errors.adjusted_amount && true }
                                helperText = { props.Errors.adjusted_amount }
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start"> { props.Currency} </InputAdornment>
                                    ),
                                }}
                                inputProps={{ step: "0.01" }}
                            /> 
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={12}>
                        <FormControl>
                            <TextareaAutosize
                                rowsMin={3}
                                id="note"
                                name="note"
                                placeholder="Note"
                                type="text"
                                required
                                value={props.FormFields.note}
                                onChange={props.HandleOnChange}
                                error = { props.Errors.note && true }
                                helperText = { props.Errors.note }
                            />
                        </FormControl>
                    </Grid>
                </Grid>
            </form>
        )
};

export const AdjustmentsComponent = (props) => {
    const [expanded, setExpanded] = React.useState(false);
    const handleChange = panel => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };
    return (
        <React.Fragment>
        <Grid item md={12}>
            <Grid item xs={12} sm={12}>
                <Accordion expanded={expanded === 'panel-0'} onChange={handleChange('panel-0')}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1bh-content"
                        id="panel1bh-header"
                    >
                        <Typography>Adjustments</Typography>
                    </AccordionSummary>
                <AccordionDetails style={{'display': 'block'}}>
                    <CustomMaterialTable
                        title="Components"
                        columns={[
                            { title: 'Component', field: 'component'},
                            { title: 'Year', field: 'year'},
                            { title: 'Amount', field: 'amount' },
                            { title: 'Note', field: 'note' }
                        ]}
                        data={props.Components}
                        options={{
                            actionsColumnIndex: -1,
                            pageSize:10,
                            pageSizeOptions: [10,20,30],
                            search: false
                        }}
                        actions={[
                            {
                                icon: 'add',
                                tooltip: 'Add Adjustment',
                                isFreeAction: true,
                                onClick: (event, newData) => { 
                                    props.AddComponent();
                                },
                                hidden: (props.Edit) ? false : true,
                            },
                            {
                                icon: 'edit',
                                tooltip: 'Edit',
                                onClick: (event, rowData) => {
                                    props.HandleUpdate(rowData.id);
                                },
                                hidden: (props.Edit) ? false : true,
                            }
                        ]}
                        editable={{
                            isDeletable: rowData => (props.Delete) ? true : false,
                            onRowDelete: rowData =>
                                new Promise((resolve, reject) => {
                                setTimeout(() => {
                                    props.OnDelete(rowData.id);
                                    resolve()
                                }, 500)
                            }),
                        }}
                    />
                    </AccordionDetails>
                </Accordion>
            </Grid>
        </Grid>
        <DialogBoxMedium
                    Open={props.Open}
                    Cancel={props.Close}
                    Title={ (props.isEditable) ? 'Edit adjustments': 'Add adjustments'}
                    OnSubmit={props.SaveAdjustments}
                    Content={<DialogAdjustments FormProps={props}/>}/>
        </React.Fragment>
    );
}

